<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj profil' : 'Dodaj operatora' }}</v-flex>

    <profile-form :schema="$schema" :edit="!!id" :simple="true" :show="show" :official="true" />

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { ProfileType } from '@witkac/kartamiejska-shared';
import { WSchema } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/official.schema';
import ProfileForm from '../../profile/ProfileForm';

const emptyData = () => ({
  login: '',
  profile: {
    firstName: '',
    lastName: '',
    type: ProfileType.OFFICIAL,
    email: '',
    phoneNumber: '',
    companyName: '',
    companyPosition: ''
  }
});

// @vuese
// Modal dodawnia/edycji profilu operatora
// @group Officials-Profile
export default {
  components: { modal, ProfileForm },
  mixins: [manageMixin('officials', {}, emptyData)],
  schema,
  props: {
    id: { type: String, required: false }
  },
  methods: {
    getId() {
      return this.stateData.profile.id;
    },
    // @vuese
    // aktualizacja profilu operatora
    update() {
      this.model.profile.userId = this.id;
      this.$emit('update', {
        id: this.getId(),
        ...this.model
      });
    }
  }
};
</script>
